import { IconButton } from '@mui/material';
import { ReactNode } from 'react';

interface NPIIconButtonProps {
    icon: ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    'aria-label'?: string;
    'data-testid'?: string;
}

function NPIIconButton({
    icon,
    onClick,
    disabled = false,
    'aria-label': ariaLabel,
    'data-testid': dataTestid,
}: Readonly<NPIIconButtonProps>) {
    return (
        <IconButton
            aria-label={ariaLabel}
            onClick={onClick}
            disabled={disabled}
            data-testid={dataTestid}
            sx={{
                width: 45,
                height: 45,
                borderRadius: 2,
                border: '2px solid',
                borderColor: '#E5E5E5',
                color: '#444444',
                transition: 'background-color 0.2s, border-color 0.2s',
                '&:hover': {
                    borderColor: '#212121',
                },
            }}
        >
            {icon}
        </IconButton>
    );
}

export default NPIIconButton;
